import {Helmet} from '@dr.pogodin/react-helmet';
import {Alert, DataStatus} from 'platform/components';
import {Show, Spinner, VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNil, isNotNil} from 'ramda';

import {useGetTitleExtensionEquipmentQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle, usePermissions} from '@dms/shared';

import {TitleExtensionEquipmentForm} from './components/TitleExtensionEquipmentForm';

export function TitleExtensionEquipment() {
  const [isResetRecoveryPending, setIsResetRecoveryPending] = useState(false);
  const equipmentQuery = useGetTitleExtensionEquipmentQuery();
  const [canUpdateTitleExtensionEquipment] = usePermissions({
    permissionKeys: ['updateTitleExtensionEquipment'],
  });
  const title = i18n.t('page.salesSettings.labels.titleExtensionEquipment');

  return (
    <>
      <Helmet title={formatDocumentTitle(title, i18n.t('page.settings.labels.title'))} />
      <SettingsTemplate
        header={{title}}
        description={i18n.t('page.titleExtensionEquipment.labels.description')}
        isLoading={equipmentQuery.isLoading}
        isError={equipmentQuery.isError && isNil(equipmentQuery.data)}
        data-testid="title-extension-equipment-settings"
      >
        <DataStatus
          data={equipmentQuery.data}
          isLoading={equipmentQuery.isLoading}
          isError={equipmentQuery.isError && isNil(equipmentQuery.data)}
        >
          {({data}) => (
            <VStack spacing={4}>
              <Show when={equipmentQuery.isFetching}>
                <Spinner size="small" />
              </Show>
              <Show
                when={
                  equipmentQuery.isError && isNotNil(equipmentQuery.data) && !isResetRecoveryPending
                }
              >
                <Alert
                  variant="error"
                  layout="detailed"
                  message={i18n.t('general.labels.somethingWentWrong')}
                  actions={[
                    {
                      variant: 'secondary',
                      title: i18n.t('general.actions.retry'),
                      onClick: () => {
                        void equipmentQuery.refetch();
                      },
                    },
                  ]}
                />
              </Show>
              <TitleExtensionEquipmentForm
                equipment={data}
                isEditable={canUpdateTitleExtensionEquipment}
                onReload={() => equipmentQuery.refetch().unwrap()}
                onResetRecoveryStateChange={setIsResetRecoveryPending}
              />
            </VStack>
          )}
        </DataStatus>
      </SettingsTemplate>
    </>
  );
}
